export const  aisReserveAssetLayerSettings= {
    aisReserveAssetLayerDefer: null,
    aisReserveAssetLayerPromise: null,
    activeAisReserveAsset: {
      styles: {
        clickedActive: {
          fillOpacity: 0.7,
          fillColor: '#4d7c28',
          fillColor: 'red',
          strokeColor: '#ffffff',
          strokeWeight: 1,
          strokeOpacity: 1,
          zIndex: -1,
        },
        hover: {
          fillOpacity: 0.5,
          strokeColor: '#c14900',
          strokeColor: '#FF0000',
          zIndex: 30,
          strokeWeight: 5,
        },
        selected: {
          fillOpacity: 1,
          strokeColor: '#c14900',
          strokeColor: '#FF0000',
          zIndex: 30,
          strokeWeight: 5,
        },
        defaultState: {
          fillOpacity: 1,
          strokeColor: '#c14900',
          strokeColor: '#FF0000',
          strokeWeight: 4,
          zIndex: 30,
        },
      },
    },
    inactiveAisReserveAsset: {
      styles: {        
        /*visible: {
          zIndex: 1,
          fillOpacity: 1,
        },
        hidden: {
          zIndex: 0,
          fillOpacity: 0,
        },
        hover: {
          fillOpacity: 0.5,
          fillColor: '#ff0000',
          strokeColor: '#ff0000',
          zIndex: 35,
          strokeWeight: 5,
        },*/
        selected: {
          fillOpacity: 0.5,
          fillColor: '#BF311A',
          strokeColor: '#BF311A',
          strokeWeight: 0,
          zIndex: 35
        },
        defaultState: {
          fillOpacity: 0,
          strokeWeight: 0,
          zIndex: 35,
        },
      },
    },
    clustererOptions: {
          styles: [
            {
              height: 43,
              width: 43,
              url: '/assets/NPWS/images/map-pins/cluster.png',
              textColor: '#000000',
              textSize: '14',
            },
            {
              height: 43,
              width: 43,
              url: '/assets/NPWS/images/map-pins/cluster.png',
              textColor: '#000000',
              textSize: '14',
            },
            {
              height: 43,
              width: 43,
              url: '/assets/NPWS/images/map-pins/cluster.png',
              textColor: '#000000',
              textSize: '14',
            },
          ],
          gridSize: 20,
          maxZoom: 11,
          calculator: function (markers, numStyles) {
            var index = 0;
            var title = ' AIS sites - click to zoom for more detail';
            var count = markers.length.toString();
            title = count + title;
            if (count < 10) {
              index = 0;
            } else if (count < 20) {
              index = 1;
            } else if (count > 20) {
              index = 2;
            }

            return {
              text: count,
              index: index,
              title: title,
            };
          },
        },
  };